import React from 'react'

import Button from 'components/shared/Button'
import Layout from 'components/shared/Layout'
import Input from 'components/shared/Input'
import { Title, Text } from 'components/typo'

import delve from 'dlv'
import classnames from 'classnames/bind'
import { useNewsletter } from 'src/hooks/useNewsletter'
import css from './styles.module.scss'
import { ReactComponent as PaperPlane } from './paper-plane.svg'

const cx = classnames.bind(css)

export const Newsletter = ({ className, newsletter }) => {
  const title = delve(newsletter, 'title')
  const text = delve(newsletter, 'text')
  const disclaimer = delve(newsletter, 'disclaimer')
  const placeholder = delve(newsletter, 'placeholder') || 'Email address'
  const submitButtonText = delve(newsletter, 'submitButtonText') || 'Subscribe'
  const portalId = delve(newsletter, 'portalId', '')
  const formGuid = delve(newsletter, 'formGuid', '')

  const {
    events: { onChange, onSubmit },
    newsletterState: { email, formStatus, isLoading, isSubmitted },
  } = useNewsletter({
    portalId,
    formGuid,
  })
  const isValid = formStatus.status === 'success'
  const message = delve(newsletter, formStatus.message, '')

  return (
    <Layout className={cx(className, css.layoutWrapper)} type="wrapper">
      <PaperPlane className={css.paperPlane} />
      <div className={css.wrapper}>
        <div className={css.content}>
          {title && (
            <Title className={css.title} size="small" tag="h2" theme="white">
              {title}
            </Title>
          )}
          {text && (
            <Text className={css.text} size="small" theme="white">
              {text}
            </Text>
          )}
        </div>
        <form className={cx(css.form)} onSubmit={onSubmit}>
          <Input
            type="email"
            name="email"
            value={email}
            onChange={onChange}
            placeholder={placeholder}
            aria-label={placeholder}
            className={css.emailInput}
            invalid={isSubmitted && !isValid}
            required
          />
          <Button
            tagName="input"
            type="submit"
            name="submit"
            theme="purple"
            value={submitButtonText}
            disabled={isLoading}
            fullWidth
            buttonClassName={css.submitButton}
          />
          {disclaimer && (
            <Text className={css.disclaimer} theme="selago">
              {disclaimer}
            </Text>
          )}
          {formStatus && isValid && (
            <Text
              size="smaller"
              theme="green"
              key={message}
              className={cx(css.formMessage, css.successMessage)}
            >
              {message}
            </Text>
          )}

          {formStatus && isSubmitted && !isValid && (
            <Text size="smaller" theme="red" className={cx(css.formMessage)}>
              {message}
            </Text>
          )}
        </form>
      </div>
    </Layout>
  )
}

export default function NewsletterBanner({
  className,
  newsletterClassName,
  newsletter,
}) {
  return (
    <Layout type="maxWidth" className={cx(css.NewsletterBanner, className)}>
      <Newsletter className={newsletterClassName} newsletter={newsletter} />
    </Layout>
  )
}
